import Dispatcher from '../dispatcher'
import {EventEmitter2} from 'eventemitter2'
import assign from 'object-assign'
import constants from '../constants'

const Store = assign({}, EventEmitter2.prototype, {
  dispatchToken: Dispatcher.register((payload) => {
    const actionType = payload.type
    const item = payload.item
    switch (actionType) {
    case constants.CHANGE_ANCHOR:
      Store.emit(actionType, item)
      break
    default:
      Store.emit(actionType, item)
      break
    }
  })
})

export default Store
